// eslint-disable-next-line import/prefer-default-export
export const SET_SEARCH_TEXT = 'searchText';
